module.exports = __webpack_public_path__ + "img/image-woman.409907f0.jpg";